import { arrayOf, func, number } from "prop-types";
import { useTranslation } from "react-i18next";
import { modulesLegend } from "../modulesLegend";
import { InfoLabel } from "@components";
import { useXlsImporterSettings } from "@tools";
import { Grid, IconButton, Tooltip, useTheme } from "@material-ui/core";
import { ListAlt } from "@material-ui/icons";
import useStyle from "@tools/XlsImporter/components/StepsFactory/steps/Steps.style";
import classnames from "classnames";
import { ColumnSelector } from "@tools/XlsImporter/components/StepsFactory/steps/Breakdown/components";

export const TableDataSelector = ({
  columnMode,
  moduleMode,
  setColumnMode,
  setModuleMode,
  colorColumn,
  ...columnSelectorProps
}) => {
  const { t } = useTranslation();
  const settings = useXlsImporterSettings();
  const classes = useStyle();
  const theme = useTheme();
  
  const {
    useFastMode,
    fastModeMapping,
    useMinMax,
  } = settings;
  
  const handleModuleSelectMode = (index) => (e) => {
    e.stopPropagation();
    if (columnMode !== null) setColumnMode(null);
    setModuleMode(index === moduleMode ? null : index);
  };
  
  const handleModuleColumnSelect = (index) => (e) => {
    if(fastModeMapping[index] !== null)
      colorColumn([fastModeMapping[index]], true, true, theme.props.selections[`level${index}`]);
    if(e.target.value !== null)
      colorColumn([e.target.value], true, false, theme.props.selections[`level${index}`]);
    settings.changeImportColumns(index, e.target.value);
  }
  
  return <Grid item container direction="column">
    <InfoLabel spacing={0} label="views.import.sub_titles.modules" className="text-secondary text-xs mb-1" />
    <Grid
      item container
      alignItems="center"
      wrap="nowrap"
      className={useFastMode ? "-mx-2" : "-mx-0-5"}
    >
      {
        modulesLegend.map((m, i) => (
          <Grid
            key={m}
            item container
            justifyContent={useFastMode ? "flex-start" : "space-between"}
            alignItems="center"
            wrap="nowrap"
            className={classnames(
              "level" + i,
              "gap-3 rounded py-1 px-2",
              useFastMode ? "w-max min-w-max" : "w-128 mx-0-5 cursor-pointer",
              !useFastMode && moduleMode === i && classes.workTypeBlockActive,
              useFastMode ? classes.borderedTransparent : classes.bordered,
            )}
            onClick={useFastMode ? undefined : handleModuleSelectMode(i)}
          >
            <p className="capitalize font-bold">
              {t("proposal_parts.module_levels.level_" + i)}
            </p>
            {
              useFastMode
                ?
                <ColumnSelector
                  name="level"
                  allowClearValue
                  {...columnSelectorProps}
                  selectedColumn={fastModeMapping[i]}
                  onChange={handleModuleColumnSelect(i)}
                  useMinMax={useMinMax}
                  size="large"
                />
                : <IconButton
                  onClick={handleModuleSelectMode(i)}
                  color="inherit"
                  className="p-1"
                >
                  <Tooltip title={t("views.import.select_rows." + i)}>
                    <ListAlt />
                  </Tooltip>
                </IconButton>
            }
          </Grid>
        ))
      }
    </Grid>
  </Grid>
}

TableDataSelector.propTypes = {
  columnMode: number.isRequired,
  moduleMode: number.isRequired,
  setColumnMode: func.isRequired,
  setModuleMode: func.isRequired,
  availableColumns: arrayOf(number).isRequired,
  takenColumns: arrayOf(number).isRequired,
  colorColumn: func.isRequired,
}
